/**
 * Legend component
 * Shows explanation for tab badges
 */

import { BaseComponent } from '../base-component';

export class Legend extends BaseComponent {
  render(): void {
    this.container.innerHTML = `
      <div class="legend">
        <div class="legend-item">
          <div class="legend-color turnstile"></div>
          <span>Requires Turnstile</span>
        </div>
        <div class="legend-item">
          <div class="legend-color auth"></div>
          <span>Requires Auth Token</span>
        </div>
      </div>
    `;
  }
}
